import * as RadixAccordion from '@radix-ui/react-accordion';
import { styled } from 'styled-components';

export const SingleAccordion = ({
  children,
  defaultValue,
}: {
  children: React.ReactNode;
  defaultValue?: string;
}) => {
  return (
    <Container>
      <RadixAccordion.Root
        className="SingleAccordionRoot"
        type="single"
        defaultValue={defaultValue}
      >
        {children}
      </RadixAccordion.Root>
    </Container>
  );
};

const Container = styled.div`
  .SingleAccordionRoot {
    h3 {
      margin: 0;
    }

    .AccordionItem {
      margin-top: 1px;
    }

    .SingleAccordionHeader {
      display: flex;
    }

    .SingleAccordionTrigger {
      padding: 0 10px;
      height: 30px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 10px;
      background-color: var(--panel-bg-color);

      overflow: hidden;
    }
    .SingleAccordionTrigger[data-state='open'] {
    }

    .SingleAccordionTriggerText {
      display: flex;
      align-items: center;

      transition: color 0.3s ease;
      color: var(--text-color-secondary);
      font-size: 12px;
      font-weight: 400;
      white-space: nowrap;
      overflow: hidden;
    }
    .SingleAccordionTriggerText > span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .SingleAccordionTrigger[data-state='open'] > .SingleAccordionTriggerText {
      color: var(--accent-color);
    }
    .AccordionTriggerText > i {
      margin-right: 5px;
      font-size: 15px;
    }

    .SingleAccordionTrigger:hover {
      background-color: var(--panel-bg-color-hover);
    }

    .SingleAccordionContent[data-state='open'] {
      /* animation: slideDown 300ms cubic-bezier(0.87, 0, 0.13, 1); */
    }
    .SingleAccordionContent[data-state='closed'] {
      /* animation: slideUp 300ms cubic-bezier(0.87, 0, 0.13, 1); */
      opacity: 0;
    }

    .SingleAccordionContentText {
      padding: 10px;
      border-left: 1px solid var(--input-border-color);
      border-right: 1px solid var(--input-border-color);
      border-radius: 15px;
    }

    .SingleAccordionChevron {
      color: var(--text-color-secondary);
      transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
    }
    .SingleAccordionTrigger[data-state='open'] > .SingleAccordionChevron {
      color: var(--accent-color);
      transform: rotate(180deg);
    }
  }

  @keyframes slideDown {
    from {
      height: 0;
      opacity: 0;
    }
    to {
      height: var(--radix-accordion-content-height);
      opacity: 1;
    }
  }

  @keyframes slideUp {
    0% {
      height: var(--radix-accordion-content-height);
      opacity: 1;
    }
    80% {
      opacity: 0;
    }
    100% {
      height: 0;
      opacity: 0;
    }
  }
`;
